<template>
    <footer class="footer bg-none mt-auto pt-5">
        <div class="container pt-5">
            <div class="row">
                <div class="col-12 col-md-4 text-start text-dark">
                    <p class="pb-3 logo-style navbar-brand">/// nologo studios</p>
                    <span class="pb-3 small text-muted">We are a dedicated digital studio committed to crafting
                        high-end, bespoke solutions for businesses worldwide. Our team of passionate technologists and
                        creators takes pride in bringing ambitious ideas to life with precision and expertise. We
                        partner with companies of all sizes, empowering them with the digital tools they need to succeed
                        and grow.</span>
                </div>
                <div class="col-12 col-md-2">
                </div>
                <div class="col-6 col-md-2 pt-4">
                    <li class="nav-item py-1"><a
                            href="https://admin.nologostudios.com/media/Nologo%20Studios%20(Pty)%20Ltd%20PAIA%20MANUAL%20Sep2024.pdf">PAIA
                            Manual</a></li>
                    <li class="nav-item py-1"><router-link to="/privacy-policy">Privacy Policy</router-link></li>
                    <li class="nav-item py-1"><router-link to="/services#FAQs">FAQ</router-link></li>
                    <li class="nav-item py-1"><router-link to="/contact">Contact Us</router-link></li>
                </div>
                <div class="col-6 col-md-2 pt-4">
                    <li class="nav-item py-1"><router-link to="/services">Services</router-link></li>
                    <li class="nav-item py-1"><router-link to="/about-us">About</router-link></li>
                    <li class="nav-item py-1"><router-link to="/careers">Careers</router-link></li>
                </div>
                <div class="col-12 col-md-2 pt-4">
                    <p class="fw-semibold pt-1 mb-1">Contact Us</p>
                    <li class="nav-item py-1"><a href="mailto:info@nologostudios.com"
                            class="fw-semibold text-primary">info@nologostudios.com</a></li>
                    <a>No. 4 Brendon Lane, Westville, 3629</a>
                </div>
                <div class="py-4">
                    <BrandMarquee />
                </div>
            </div>
        </div>

        <div class="container pb-3">
            <div class="row">
                <div class="col-4 text-start text-dark d-flex justify-content-start">
                    <div class="footer-item-1">
                        <a href="https://za.linkedin.com/company/nologo-studios" target="_blank"><i
                                class="fa-brands fa-linkedin-in h3 me-3"></i></a>
                        <a href="https://www.facebook.com/nologostudios/" target="_blank"><i
                                class="fa-brands fa-facebook h3"></i></a>
                    </div>
                </div>
                <div class="col-4 d-flex justify-content-center">
                    <div class="footer-item-2">
                        <span class="text-muted small">© {{ currentYear }}</span>
                    </div>
                </div>
                <div class="col-4 d-flex justify-content-end">
                    <div class="footer-item-3 text-end">
                        <span class="text-muted small d-block">All rights reserved</span>
                        <span class="text-muted small d-block mt-2">Powered by Nologo Studios</span>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import BrandMarquee from "@/components/general/BrandMarquee.vue";
import { useApolloClient } from '@vue/apollo-composable';
import { getBrandMarquee } from "@/utils/graphql";

const currentYear = new Date().getFullYear();
const logos = ref<Array<{ src: string; alt: string; link: string }>>([]);

const { resolveClient } = useApolloClient();
const ApolloClient = resolveClient();

onMounted(async () => {
    try {
        const result = await getBrandMarquee(ApolloClient);
        logos.value = result as Array<{ src: string; alt: string; link: string }>;
    } catch (error) {
        console.error("Failed to load marquee logos in Footer:", error);
    }
});
</script>

<style scoped lang="scss">
@media (min-width: 500px) {

    .container-sm,
    .container {
        max-width: 97%;
    }
}

@media (min-width: 768px) {

    .container-md,
    .container-sm,
    .container {
        max-width: 95%;
    }
}

@media (min-width: 992px) {

    .container-lg,
    .container-md,
    .container-sm,
    .container {
        max-width: 95%;
    }
}

@media (min-width: 1200px) {

    .container-xl,
    .container-lg,
    .container-md,
    .container-sm,
    .container {
        max-width: 95%;
    }
}

@media (min-width: 1400px) {

    .container-xxl,
    .container-xl,
    .container-lg,
    .container-md,
    .container-sm,
    .container {
        max-width: 1420px;
    }
}

.footer {
    .nav-item {
        list-style-type: none;

        a {
            transition: 0.25s;
            font-weight: 500;
        }
    }

    a {
        transition: 0.25s;
    }
}
</style>